// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"styles__breadcrumb___63_A_","icon":"styles__icon___CJeNY"};